import { render, staticRenderFns } from "./SystemSettings.vue?vue&type=template&id=254a9ff5"
import script from "./SystemSettings.vue?vue&type=script&lang=js"
export * from "./SystemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports